import React, { useEffect, useState } from 'react';
import './PiAppsExploreScreen.css';
import { useNavigate } from 'react-router-dom';
import api from '../api';

import backIcon from '../assets/backspace-icon.png';
import placeholderLogo from '../assets/placeholder-logo.png';
import goldTickIcon from '../assets/goldtick-icon.png';

const CATEGORIES = [
  'All',
  'Commerce',
  'Games',
  'NFT',
  'Social',
  'Education',
  'Utility',
  'Finance',
  'Other',
];

function PiAppsExploreScreen({ user }) {
  const navigate = useNavigate();

  const [apps, setApps] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchApps = async () => {
      setLoading(true);

      try {
        const url =
          selectedCategory === 'All'
            ? '/apps/discovery/browse'
            : `/apps/discovery/browse?category=${encodeURIComponent(selectedCategory)}`;


const res = await api.get(url);

const apps = Array.isArray(res.data?.apps)
  ? res.data.apps
  : Array.isArray(res.data)
    ? res.data
    : [];

setApps(apps);

      } catch (err) {
        console.error('Failed to fetch Pi Apps:', err);
        setApps([]);
      } finally {
        setLoading(false);
      }
    };

    fetchApps();
  }, [selectedCategory]);

  const getAppLogo = (app) => {
    const logo = app?.profilePic || app?.logo || app?.appLogo;

    if (
      !logo ||
      String(logo).trim() === '' ||
      logo === 'undefined' ||
      logo === null
    ) {
      return placeholderLogo;
    }

    return logo;
  };

  const formatFollowers = (count = 0) => {
    const n = Number(count) || 0;

    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M followers`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}K followers`;
    if (n === 1) return '1 follower';

    return `${n} followers`;
  };

  const handleAppClick = (app) => {
    if (!app?.username) return;
    navigate(`/user/${app.username}`);
  };

  return (
    <div className="pi-apps-explore-screen">
      <div className="pi-apps-top-bar">
        <button
          type="button"
          className="pi-apps-back-btn"
          onClick={() => navigate(-1)}
        >
          <img src={backIcon} alt="Back" className="pi-apps-back-icon" />
        </button>

        <div className="pi-apps-top-title">
          <h2>Pi Apps</h2>
          <span>Discover public apps in the BarterFi ecosystem</span>
        </div>
      </div>

      <div className="pi-apps-category-row">
        {CATEGORIES.map((category) => (
          <button
            type="button"
            key={category}
            className={`pi-apps-category-pill ${
              selectedCategory === category ? 'active' : ''
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="pi-apps-scroll-area">
        {loading ? (
          <p className="pi-apps-empty-text">Loading Pi Apps...</p>
        ) : apps.length === 0 ? (
          <div className="pi-apps-empty-state">
            <h3>No apps found</h3>
            <p>
              There are no active public Pi Apps in this category yet.
            </p>
          </div>
        ) : (
          apps.map((app) => (
            <div
              className="pi-app-card"
              key={app._id || app.username}
              onClick={() => handleAppClick(app)}
            >
              <img
                src={getAppLogo(app)}
                alt={app.name || 'Pi App'}
                className="pi-app-logo"
              />

              <div className="pi-app-info">
                <div className="pi-app-title-row">
                  <h3>{app.name || app.username}</h3>

                  <img
                    src={goldTickIcon}
                    alt="Verified app"
                    className="pi-app-verified-icon"
                    title="App account"
                  />
                </div>


                <div className="pi-app-meta-row">
                  {app.category && (
                    <span className="pi-app-category">{app.category}</span>
                  )}

                  <span className="pi-app-followers">
                    {formatFollowers(app.followersCount)}
                  </span>
                </div>

                {(app.bio || app.domain) && (
                  <p className="pi-app-description">
                    {app.bio || app.domain}
                  </p>
                )}

                {app.domain && (
                  <span className="pi-app-domain">{app.domain}</span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default PiAppsExploreScreen;
